import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LandingNewRoutingModule } from './landing-new-routing.module';
import { LandingNewComponent } from './landing-new.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { BannerComponent } from './banner/banner.component';
import { SubBannerComponent } from './sub-banner/sub-banner.component';
import { WhyUsComponent } from './why-us/why-us.component';
import { LaunchCryptoComponent } from './launch-crypto/launch-crypto.component';
import { ExploreComponent } from './explore/explore.component';
import { TokenFeaturesComponent } from './token-features/token-features.component';
import { NftFeaturesComponent } from './nft-features/nft-features.component';
import { UpcomingComponent } from './upcoming/upcoming.component';
import { BxInfinityChainComponent } from './bx-infinity-chain/bx-infinity-chain.component';
import { NextFeaturesComponent } from './next-features/next-features.component';
import { RoadmapComponent } from './roadmap/roadmap.component';
import { OurTeamComponent } from './our-team/our-team.component';
import { OurBlogComponent } from './our-blog/our-blog.component';
import { NewsEventsComponent } from './news-events/news-events.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { PartnersComponent } from './partners/partners.component';


@NgModule({
  declarations: [
    LandingNewComponent,
    BannerComponent,
    SubBannerComponent,
    WhyUsComponent,
    LaunchCryptoComponent,
    ExploreComponent,
    TokenFeaturesComponent,
    NftFeaturesComponent,
    UpcomingComponent,
    BxInfinityChainComponent,
    NextFeaturesComponent,
    RoadmapComponent,
    OurTeamComponent,
    OurBlogComponent,
    NewsEventsComponent,
    ContactUsComponent,
    PartnersComponent,
  ],
  imports: [
    CommonModule,
    LandingNewRoutingModule,
    SharedModule
  ]
})
export class LandingNewModule { }
